module.exports = __webpack_public_path__ + "static/media/sourcing_cv.0596948d.jpg";